import { render, staticRenderFns } from "./VConfirmationModal.vue?vue&type=template&id=27bcf9df&"
import script from "./VConfirmationModal.vue?vue&type=script&lang=ts&"
export * from "./VConfirmationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports